<template>
  <div class="ticket-process-container">
    <el-card>
      <!-- 操作栏 -->
      <div class="filter-container">
        <el-button type="primary" @click="handleCreate">新增</el-button>
      </div>

      <!-- 表格 -->
      <el-table
          :data="tableData"
          border
          style="width: 100%">
<!--        <el-table-column type="index" label="序号" width="80" />-->
        <el-table-column prop="processIndex" label="排序" width="120" />
        <el-table-column prop="processName" label="流程名称" />
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" @click="showTicketProcessHead(scope.row)">查看流程</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 表单对话框 -->
      <el-dialog :title="dialogStatus"
                 :visible.sync="dialogFormVisible"
                 append-to-body
                 destroy-on-close>
        <el-form
            ref="dataForm"
            :model="temp"
            :rules="rules"
            label-position="left"
            label-width="100px">
          <el-form-item label="排序" prop="processIndex">
            <el-input-number
                style="width: 180px"
                v-model.number="temp.processIndex"
                type="number"
                :precision="0"
                :controls="false"
                placeholder="请输入排序号"
            />
          </el-form-item>
          <el-form-item label="流程名称" prop="processId">
            <el-select v-model="temp.processId" placeholder="请选择">
              <el-option
                  v-for="item in processOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button type="primary" @click="dialogStatus==='新增'?createData():updateData()">确认</el-button>
        </div>
      </el-dialog>
      <el-dialog title="查看流程"
                 :visible.sync="dialogHeadVisible"
                 append-to-body
                 destroy-on-close>
        <el-card label="头信息配置" name="Head">
          <TicketProcessHead
              :key="processId"
              :typeId="typeId"
              :typeName="typeName"
              :processId="processId"
          />
        </el-card>
        <el-card label="体信息配置" name="LineHead">
          <TicketProcessLineHead
              :key="processId"
              :typeId="typeId"
              :typeName="typeName"
              :processId="processId"
          />
        </el-card>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogHeadVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket'
import TicketProcessHead from "@/views/ticket/TicketProcessHead.vue";
import TicketProcessLineHead from "@/views/ticket/TicketProcessLineHead.vue";

export default {
  components: {
    TicketProcessHead,
    TicketProcessLineHead
  },
  props: {
    typeId: {
      type: Number,
      required: true
    },
    typeName: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tableData: [],
      processOptions: [],
      dialogFormVisible: false,
      dialogHeadVisible: false,
      processId: undefined,
      dialogStatus: '',
      temp: {
        id: undefined,
        processId: '',
        processName: '',
        typeId: this.typeId,
        typeName: this.typeName,
        processIndex: undefined  // 新增排序字段
      },
      rules: {
        processId: [{ required: true, message: '必填项', trigger: 'change' }],
        processIndex: [
          { required: true, message: '必填项', trigger: 'blur' },
          { type: 'number', message: '必须为数字' }
        ]
      },
      activeName: 'Head'
    }
  },
  created() {
    this.fetchData()
    this.getProcessOptions()
  },
  methods: {
    // 获取表格数据
    async fetchData() {
      const res = await requestTicket.post('/Ticketing/ticket-process/findAll')
      this.tableData = res.data.filter(v => v.typeId === this.typeId).sort((a, b) => a.processIndex - b.processIndex)  // 新增排序逻辑
    },
    // 获取流程选项
    async getProcessOptions() {
      const res = await requestTicket.post('/Ticketing/process/findAll')
      this.processOptions = res.data
    },
    // 新增操作
    handleCreate() {
      this.dialogStatus = '新增'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.temp = {
          ...this.temp,
          id: undefined,
          processId: ''
        }
      })
    },
    async showTicketProcessHead(row) {
      this.processId = row.processId
      this.$nextTick(() => {
        this.dialogHeadVisible = true
      })
    },
    // 编辑操作
    handleEdit(row) {
      this.temp = Object.assign({}, row)
      this.dialogStatus = '编辑'
      this.dialogFormVisible = true
    },
    // 提交新增
    async createData() {
      this.$refs['dataForm'].validate(async valid => {
        if (valid) {
          const selectedProcess = this.processOptions.find(
              v => v.id === this.temp.processId
          )
          const params = {
            ...this.temp,
            processName: selectedProcess.name
          }
          await requestTicket.post('/Ticketing/ticket-process/save', params)
          this.dialogFormVisible = false
          this.fetchData()
        }
      })
    },
    // 提交修改
    async updateData() {
      this.$refs['dataForm'].validate(async valid => {
        if (valid) {
          const selectedProcess = this.processOptions.find(
              v => v.id === this.temp.processId
          )
          const params = {
            ...this.temp,
            processName: selectedProcess.name
          }
          await requestTicket.post('/Ticketing/ticket-process/save', params)
          this.dialogFormVisible = false
          this.fetchData()
        }
      })
    },
    // 删除操作
    handleDelete(row) {
      this.$confirm('确认删除？').then(async () => {
        await requestTicket.delete(`/Ticketing/ticket-process/${row.id}`)
        this.fetchData()
      })
    }
  }
}
</script>

<style scoped>
.filter-container {
  margin-bottom: 20px;
}
.el-table {
  margin-top: 20px;
}
</style>